import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { emptyCircleVariants, type EmptyCircleProps } from './variants';

/**
 * Circular thumbnail for non-user entities (events, questions, leagues, etc).
 *
 * Renders an `<img>` when `src` is provided; otherwise falls back to an
 * empty light gray circle.
 *
 * For user avatars (which fall back to a user silhouette), use `Avatar`.
 *
 * @example
 * ```tsx
 * <EmptyCircle src="/event.jpg" size="lg" alt="Event" />
 * <EmptyCircle size="sm" />
 * ```
 */
const EmptyCircle = forwardRef<HTMLDivElement, EmptyCircleProps>(({ className, size, src, alt, ...props }, ref) => (
  <div ref={ref} className={cn(emptyCircleVariants({ size }), className)}>
    {src && <img src={src} alt={alt ?? ''} className="size-full object-cover" {...props} />}
  </div>
));
EmptyCircle.displayName = 'EmptyCircle';

export { EmptyCircle };
